<footer
  [class]="
    'footer ' +
    (footerLite === 'true' ? 'footer-lite ' : '') +
    (isBiometrics === 'true' ? 'footer-bm' : '')
  "
>
  <div class="container">
    <div *ngIf="footerError === 'false'" class="box-footer">
      <p *ngIf="footerLite === 'true'">www.avvillas.com.co</p>
      <p class="foreign-text" *ngIf="footerLite === 'false'">
        <span>
          Para conocer más beneficios del producto
          <a
            target="_blank"
            href="https://www.avvillas.com.co/cdt-en-linea"
            rel="noopener noreferrer"
            >haz clic aquí.</a
          >
          Conoce los reglamentos de los productos y condiciones
          <a
            target="_blank"
            href="https://www.avvillas.com.co/cdt-en-linea"
            rel="noopener noreferrer"
            >aquí.</a
          >
          Si eres extranjero o menor de edad puedes acercarte a nuestras
          oficinas y hacer tu solicitud.
          <a
            target="_blank"
            href="https://www.avvillas.com.co/"
            rel="noopener noreferrer"
            >www.avvillas.com.co</a
          >
        </span>
      </p>
      <picture class="logo-footer">
        <img [src]="assetsUrl + '/common/logo/new_logo_aval.svg'" alt="" />
        <img
          *ngIf="footerLite === 'false'"
          [src]="assetsUrl + '/common/logo/new_fogafin.svg'"
          alt=""
        />
      </picture>

      <picture *ngIf="footerLite === 'false'" class="vigilado">
        <img [src]="assetsUrl + '/images/cdt/vigilado/group-5.svg'" alt="" />
        <img [src]="assetsUrl + '/common/logo/new_fogafin.svg'" alt="" />
      </picture>
    </div>

    <div *ngIf="footerError === 'true'" class="box-footer-error">
      <p>www.avvillas.com.co</p>
      <p class="error-description" *ngIf="footerError === 'true'">
        Si tienes alguna inquietud comunícate en Bogotá: 336 3199 - 444 1777 -
        Barranquilla: 330 4330 - Bucaramanga: 630 2980 - Medellín: 325 6000 -
        Cali: 8859595 - Resto del país: 01 8000 51 8000
      </p>
      <picture class="logo-footer-error">
        <img [src]="assetsUrl + '/common/logo/new_logo_aval.svg'" alt="" />
      </picture>
    </div>
  </div>
</footer>
